angular.module('iw.frontyard.signup')
    .service('IwocaCookies', function ($document) {

        class IwocaCookies {

            static extractCookie(cookieString, cookieName) {
                var regExp = new RegExp('(?:(?:^|.*;\\s*)' + cookieName + '\\s*\\=\\s*([^;]*).*$)|^.*$');
                return cookieString.replace(regExp, '$1');
            }

            static getCsrfToken() {
                return this.extractCookie($document.prop('cookie'), 'csrftoken');
            }

            static getGoogleOptimizer() {
                return this.extractCookie($document.prop('cookie'), '_gaexp');
            }
        }

        return IwocaCookies;
    });
